// UI Components JavaScript
// Общие компоненты для всего сайта

// Инициализация всех UI компонентов
document.addEventListener('DOMContentLoaded', function() {
    // Инициализация Bootstrap компонентов
    initializeBootstrapComponents();
    
    // Инициализация валидации форм
    initializeFormValidation();
    
    // Инициализация модальных окон
    initializeModals();
    
    // Инициализация подсказок для чекбоксов согласия
    initializeConsentCheckboxHints();

    // Кнопки-CTA с переходом по data-button-href
    initializeButtonHrefNavigation();

    // Кнопки каталога, открывающие callback modal с контекстом товара
    initializeCallbackProductButtons();

    // Плавный скролл для внутренних якорных ссылок
    initializeSmoothAnchorNavigation();

    // Кнопка "вверх" с учетом cookie-баннера
    initializeScrollTopButton();
});

function initializeBootstrapComponents() {
    // Bootstrap tooltips
    var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
    var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
        return new bootstrap.Tooltip(tooltipTriggerEl);
    });
    
    // Bootstrap popovers
    var popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'));
    var popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
        return new bootstrap.Popover(popoverTriggerEl);
    });
}

function initializeFormValidation() {
    // Валидация форм с использованием jQuery Validation
    $('form[data-validate="true"]').each(function() {
        $(this).validate({
            errorClass: 'is-invalid',
            validClass: 'is-valid',
            highlight: function(element, errorClass, validClass) {
                $(element).addClass(errorClass).removeClass(validClass);
            },
            unhighlight: function(element, errorClass, validClass) {
                $(element).removeClass(errorClass).addClass(validClass);
            }
        });
    });
}

function initializeModals() {
    // Use Bootstrap's native backdrop click handling instead of custom jQuery handler
    // Bootstrap automatically handles backdrop clicks with data-bs-backdrop="true"
}

function initializeConsentCheckboxHints() {
    // Управление подсказками для чекбоксов согласия
    document.querySelectorAll('.consent-checkbox__input').forEach(function(checkbox) {
        var hint = checkbox.parentElement.querySelector('.consent-checkbox__hint');
        if (!hint) return;
        
        var tooltip = bootstrap.Tooltip.getInstance(hint);
        
        function updateHintVisibility() {
            if (checkbox.checked) {
                // Скрываем подсказку если чекбокс отмечен
                hint.style.display = 'none';
                if (tooltip) tooltip.hide();
            } else {
                // Показываем подсказку если чекбокс не отмечен и он обязательный
                var isRequired = checkbox.dataset.required === 'true';
                hint.style.display = isRequired ? 'inline-flex' : 'none';
            }
        }
        
        // Обновляем видимость при изменении состояния
        checkbox.addEventListener('change', updateHintVisibility);
        
        // Инициализация при загрузке
        updateHintVisibility();
    });
}

function initializeButtonHrefNavigation() {
    document.addEventListener('click', function(event) {
        var button = event.target.closest('button[data-button-href]');
        if (!button || button.disabled) return;

        var href = button.getAttribute('data-button-href');
        if (!href) return;

        if (href.charAt(0) === '#' && scrollToHashTarget(href, true)) {
            event.preventDefault();
            return;
        }

        window.location.href = href;
    });
}

function initializeCallbackProductButtons() {
    document.addEventListener('click', function(event) {
        var button = event.target.closest('button[data-callback-product]');
        if (!button || button.disabled) return;

        var productName = button.getAttribute('data-callback-product');
        if (!productName) return;

        var modal = document.getElementById('callbackModal');
        if (!modal) return;

        var commentField = modal.querySelector('textarea[id^="comment-"], input[id^="comment-"]');
        if (!commentField) return;

        if (!commentField.value || commentField.value.trim() === '') {
            commentField.value = 'Интересует: ' + productName;
        }
    });
}

function initializeSmoothAnchorNavigation() {
    document.addEventListener('click', function(event) {
        var link = event.target.closest('a[href]');
        if (!link) return;
        if (link.hasAttribute('download')) return;

        var href = link.getAttribute('href');
        if (!href || href === '#' || href.indexOf('#') === -1) return;
        if (link.hasAttribute('data-bs-toggle')) return;

        var url;
        try {
            url = new URL(href, window.location.origin);
        } catch (e) {
            return;
        }

        if (url.origin !== window.location.origin || url.pathname !== window.location.pathname) {
            return;
        }

        if (!url.hash || url.hash === '#') return;

        if (scrollToHashTarget(url.hash, true)) {
            event.preventDefault();
        }
    });
}

function scrollToHashTarget(hash, updateHistory) {
    if (!hash || hash.charAt(0) !== '#') return false;

    var targetElement = document.querySelector(hash);
    if (!targetElement) return false;

    targetElement.scrollIntoView({ behavior: 'smooth', block: 'start' });

    if (updateHistory && window.history && window.history.replaceState) {
        window.history.replaceState(null, '', hash);
    }

    return true;
}

function initializeScrollTopButton() {
    var button = document.querySelector('[data-scroll-top]');
    if (!button || button.dataset.initialized === 'true') return;
    button.dataset.initialized = 'true';

    var cookieBanner = document.querySelector('.cookie-consent');
    var documentElement = document.documentElement;

    function getBaseOffset() {
        return window.innerWidth <= 480 ? 10 : 20;
    }

    function updateButtonVisibility() {
        if (window.scrollY > 500) {
            button.classList.add('is-visible');
        } else {
            button.classList.remove('is-visible');
        }
    }

    function updateButtonOffset() {
        var offset = getBaseOffset();

        if (cookieBanner && cookieBanner.classList.contains('show')) {
            offset += cookieBanner.offsetHeight + 12;
        }

        documentElement.style.setProperty('--scroll-top-offset', offset + 'px');
    }

    button.addEventListener('click', function() {
        scrollPageToTopSmooth();
    });

    window.addEventListener('scroll', updateButtonVisibility, { passive: true });
    window.addEventListener('resize', updateButtonOffset);

    if (cookieBanner) {
        var observer = new MutationObserver(function() {
            updateButtonOffset();
        });
        observer.observe(cookieBanner, { attributes: true, attributeFilter: ['class', 'style'] });
    }

    updateButtonVisibility();
    updateButtonOffset();
}

function scrollPageToTopSmooth() {
    var startY = window.scrollY || window.pageYOffset || 0;
    if (startY <= 0) return;

    var duration = 450;
    var startTime = null;

    function easeOutCubic(t) {
        return 1 - Math.pow(1 - t, 3);
    }

    function step(timestamp) {
        if (startTime === null) {
            startTime = timestamp;
        }

        var elapsed = timestamp - startTime;
        var progress = Math.min(elapsed / duration, 1);
        var eased = easeOutCubic(progress);
        var nextY = Math.round(startY * (1 - eased));

        window.scrollTo(0, nextY);

        if (progress < 1) {
            window.requestAnimationFrame(step);
        }
    }

    if (window.requestAnimationFrame) {
        window.requestAnimationFrame(step);
    } else {
        window.scrollTo(0, 0);
    }
}

// Глобальные функции для доступа из HTML
window.initializeUIComponents = initializeBootstrapComponents;
window.initializeConsentCheckboxHints = initializeConsentCheckboxHints;
